module.exports = __webpack_public_path__ + "img/聚划算品牌特卖示例图.992fce10.jpeg";